// extracted by mini-css-extract-plugin
export var linkStyle = "affiliateLink-module--linkStyle--BGHcD";
export var disclosure = "affiliateLink-module--disclosure--X01Xb";